import React, { useEffect } from 'react'
import { Upload } from 'antd'
import type { UploadProps } from 'antd'
import { readExcelFile } from './helpers'
import { useTranslation } from 'next-i18next'
import { InboxOutlined } from '@ant-design/icons'
import { showNotification } from 'src/core/helpers'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { resetMassiveCalculationFileData, setMassiveCalculationNextButtonDisabled } from 'src/features'
const { Dragger } = Upload


const ImportTransactionStep: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { fileKeys } = useAppSelector((state) => state.admin.massiveCalculation)

  useEffect(() => {
    dispatch(setMassiveCalculationNextButtonDisabled(fileKeys.length === 0))
  }, [dispatch, fileKeys])


  const props: UploadProps = {
    name: 'file',
    multiple: false,
    beforeUpload: file => {
      readExcelFile(dispatch, file, file.name)
      showNotification('success', t('admin.MassiveCalculate.FileUploadSuccess'))
      return false
    },
    onChange(info) {
      const { status } = info.file
      if (status === 'error') {
        showNotification('error', t('admin.MassiveCalculate.FileUploadError'))
      } else if (status === 'removed') {
        dispatch(resetMassiveCalculationFileData())
        showNotification('success', t('admin.MassiveCalculate.FileUploadRemoved'))
      }
    },
  }

  return (
    <>
      <Dragger
        {...props}
        accept='.xlsx, .xls'
        maxCount={1}
      >
        <p className='ant-upload-drag-icon'>
          <InboxOutlined />
        </p>
        <p className='ant-upload-text'>
          {t('admin.MassiveCalculate.UploadText')}
        </p>
        <p className='ant-upload-hint'>
          {t('admin.MassiveCalculate.FileAllowed')}
        </p>
      </Dragger>
    </>
  )
}

export default ImportTransactionStep
